import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { GetRoleList } from "../../../actions/RoleActions";
const RolesSidebar = () => {
  const dispatch = useDispatch();
  const loginInfo = useSelector((state) => state.loginInfo.value);
  const roleListInfo = useSelector((state) => state.roleListInfo.value);
  const roleInfo = useSelector((state) => state.roleInfo.value);
  const [roleList, updateRoleList] = useState([]);
  const [trinFormsRoleList, updateTrinFormsRoleList] = useState([]);
  const [searchText, updateSearchText] = useState("");
  const [filteredRoleList, updateFilteredRoleList] = useState([]);
  const [rolesToShow, updateRolesToShow] = useState("TrinDocs");
  const [maxHeight, updatemaxHeight] = useState(window.innerHeight - 280);
  useEffect(() => {
    if (roleListInfo.loaded === false) {
      GetRoleList(dispatch);
    } else {
      updateRoleList(roleListInfo.roleList);
      updateFilteredRoleList(roleListInfo.roleList);
      updateTrinFormsRoleList(roleListInfo.trinFormsRoles);
    }
    if (roleInfo.deleted) {
      GetRoleList(dispatch);
    }
  }, [roleListInfo, roleInfo, loginInfo]);
  const onSearchChange = (e) => {
    let search = e.target.value;
    if (search === "") {
      let newList = [...roleList];
      updateSearchText(search);
      updateFilteredRoleList(newList);
    } else {
      let newList = [];
      roleList.forEach((role) => {
        if (role.name.toLowerCase().includes(search.toLowerCase())) {
          newList.push(role);
        }
      });
      updateSearchText(search);
      updateFilteredRoleList(newList);
    }
  };
  const changeRolesToShow = (e) => {
    updateRolesToShow(e);
  };
  let listOfRoles;
  if (roleList !== null) {
    listOfRoles = filteredRoleList.map((role) => /* @__PURE__ */ React.createElement("div", { key: role.id }, /* @__PURE__ */ React.createElement(
      Link,
      {
        className: "sidebar-link",
        to: "/Admin/RolesView/" + role.id,
        style: { cursor: "Pointer", wordWrap: "break-word" }
      },
      role.name
    )));
  } else {
    listOfRoles = /* @__PURE__ */ React.createElement("div", null);
  }
  let trinFormsRoles;
  if (roleList !== null) {
    trinFormsRoles = trinFormsRoleList.map((role) => /* @__PURE__ */ React.createElement("div", { key: role.id }, /* @__PURE__ */ React.createElement(
      Link,
      {
        className: "sidebar-link",
        to: "/Admin/RolesView/" + role.id,
        style: { cursor: "Pointer", wordWrap: "break-word" }
      },
      role.name
    )));
  } else {
    trinFormsRoles = /* @__PURE__ */ React.createElement("div", null);
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "d-flex flex-column p-3 text-white bg-dark",
      style: { height: "100%", width: "245px" }
    },
    /* @__PURE__ */ React.createElement(
      Link,
      {
        to: "/v/administration/roles",
        className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
      },
      /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-user-friends" }), "   ", "Roles")
    ),
    /* @__PURE__ */ React.createElement("hr", null),
    /* @__PURE__ */ React.createElement("div", { className: "input-group rounded", style: { marginBottom: "16px" } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "search",
        value: searchText,
        className: "form-control",
        placeholder: "Search",
        "aria-label": "Search",
        onChange: onSearchChange,
        "aria-describedby": "search-addon"
      }
    ), /* @__PURE__ */ React.createElement("span", { className: "input-group-text border-0", id: "search-addon" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" }))),
    /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/RolesView/0" }, "New Role"),
    /* @__PURE__ */ React.createElement("hr", null),
    rolesToShow === "TrinDocs" && /* @__PURE__ */ React.createElement("div", { className: "coolScroll", style: { maxHeight: `${maxHeight}px`, overflowY: "auto" } }, listOfRoles),
    rolesToShow !== "TrinDocs" && /* @__PURE__ */ React.createElement("div", null, trinFormsRoles)
  );
};
export default RolesSidebar;
